module.exports = __webpack_public_path__ + "static/media/b1s.b7eaf66d.png";